import { typeUtils } from '@festina-life/core'
import {
  FormikDateInput,
  FormikFilterFormButtons,
  FormikForm,
} from '@festina-life/ui/formikForms'
import { useTranslate } from '@festina-life/ui/hooks'

import type { TradeCycleFilterFormValues } from './tradeCycleFilterUtils'

const validateKey = typeUtils.createValidator<TradeCycleFilterFormValues>()

type Props = {
  initialValues: TradeCycleFilterFormValues
  onSearch: (values: TradeCycleFilterFormValues) => void
}

export const TradeCycleFiltersForm = ({ initialValues, onSearch }: Props) => {
  const translate = useTranslate()

  return (
    <FormikForm
      initialValues={initialValues}
      onSubmit={onSearch}
      shouldSubmitOnMount
    >
      <div className="flex gap-2 flex-wrap">
        <FormikDateInput
          name={validateKey('fromDate')}
          label={translate('tradeCycleOverview.filter.fromDate')}
        />
        <FormikDateInput
          name={validateKey('toDate')}
          label={translate('tradeCycleOverview.filter.toDate')}
        />
        <FormikFilterFormButtons />
      </div>
    </FormikForm>
  )
}
